<template>
    <main v-if="plano">
        <section class="info-bloc-pdf">
            <v-style>
                .handle{display:none} .info-bloc-pdf{ padding:40px; } .info-bloc-pdf p { font-size:15px; margin: 5px 0px } .info-bloc-pdf p span {
                color: {{ brandColors.color2 }} } .info-bloc-pdf h1 { text-transform:uppercase; font-size: 40px;color: {{ brandColors.color4 }} }
            </v-style>
            <v-style>
                .highlight-line { margin: 10px 0px; font-size: 15px; } .highlight-line span { display: inline-block;vertical-align: middle; width:
                15px; height: 15px; border: 1px #ccc solid;}
            </v-style>
            <h1>{{ currentTrad.informationGeneralTitle }}</h1>
            <p>
                {{ currentTrad.name }} : <span>{{ plano.name }}</span>
            </p>
            <p v-if="plano.zone && plano.zone.name">
                {{ currentTrad.zone }} : <span>{{ plano.zone.name }}</span>
            </p>

            <p>
                {{ currentTrad.designAndCampaign }} :
                <span>{{ standDesign && standDesign.name }} {{ plano.campaign && "/ " + plano.campaign.name }}</span>
            </p>

            <p>
                {{ currentTrad.createdOn }} <span>{{ plano.createdAt || plano.createdUser.dateCreated }}</span> {{ $t("common.by") }}
                <span>{{ createdBy }}</span>
            </p>
            <p>
                {{ currentTrad.modifiedOn }} <span>{{ plano.modifiedDate || plano.modifiedUser.modifiedDate }}</span> {{ $t("common.by") }}
                <span>{{ modifiedBy }}</span>
            </p>

            <h1>{{ currentTrad.informationPlanogramTitle }}</h1>

            <p>
                {{ currentTrad.size }} : <span>{{ plano.height || plano.heightExternal }}mm X {{ plano.width || plano.widthExternal }}mm</span>
            </p>
            <p>
                {{ $t("plano.infoModal.type") }} :
                <span>
                    {{
                        getTranslate(
                            systemTypeObject &&
                                systemTypeObject.systemType &&
                                systemTypeObject.systemType.terms &&
                                systemTypeObject.systemType.terms.name
                        )
                    }}
                </span>
            </p>
            <p>
                {{ $trad.templatePlano.template }}: <span> {{ plano.template.name }} </span>
            </p>
            <div v-if="count(allModules) > 0">
                <p>
                    {{ currentTrad.modulesQuantity }} : <span> {{ count(allModules) }} </span>
                </p>
                <p>
                    {{ currentTrad.modulesSku }} : <span> {{ sku(allModules) }} </span>
                </p>
            </div>
            <div v-if="count(allShades) > 0">
                <p>
                    {{ currentTrad.shadesQuantity }} : <span> {{ count(allShades) }} </span>
                </p>
                <p>
                    {{ currentTrad.shadesSku }} : <span> {{ sku(allShades) }} </span>
                </p>
            </div>
            <p v-if="count(allShelves) > 0">
                {{ currentTrad.shelvesQuantity }} : <span> {{ count(allShelves) }} </span>
            </p>
            <p v-if="count(allCaddy) > 0">
                {{ currentTrad.caddiesQuantity }} : <span> {{ count(allCaddy) }} </span>
            </p>

            <h1>{{ currentTrad.repartitionTitle }}</h1>

            <p style="text-transform: uppercase" v-for="category in sortedCategories" :key="category.id">
                {{ category.name }} : <span> {{ Math.round(category.percentage * 100) }}% </span>
            </p>

            <h1>{{ "highLights" }}</h1>
            <p v-if="highlights.length === 0">{{ currentTrad.noHighlightColor }}</p>
            <div class="highlight-line" style="text-transform: uppercase" v-for="highlight in highlights" :key="highlight.id">
                {{ highlight.label }} : <span :style="{ backgroundColor: highlight.code || 'black' }"> </span>
            </div>
        </section>
    </main>
</template>

<script>
import PlanoStatsMixin from "@/mixins/PlanoStatsMixin";
import { mapGetters } from "vuex";
import cacheService from "@/services/cache";

export default {
    data: () => ({}),
    props: {
        plano: {
            type: Object
        }
    },
    mixins: [PlanoStatsMixin],
    computed: {
        ...mapGetters("currentUser", ["currentBrand"]),
        createdBy() {
            return this.plano.createdUser.firstname + " " + this.plano.createdUser.lastname;
        },
        modifiedBy() {
            return this.plano.modifiedUser.firstname + " " + this.plano.modifiedUser.lastname;
        },
        systemTypeObject() {
            return this.plano.template || this.plano;
        },
        standDesign() {
            return this.plano.stand_design || this.plano.standDesign;
        },
        currentTrad() {
            return this.$trad.plano.infoModal;
        },
        brandColors() {
            return cacheService.getBrandColors();
        },
        highlights() {
            return this.currentBrand.brandHightlighColorByBrand || [];
        }
    }
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// InfoPagePdf.vue?7b027ad2